import React from "react";
import { Badge, Text } from "@bookingcom/bui-react";
import cxx from "../../__utils/cxx.js";
import styles from "./styles.module.css";
export function CardStops(props) {
    const { stops, duration, alignDuration = "center", text, className, attributes, durationAttributes, variant = "outline", drawConnector = true, index } = props;
    return (React.createElement("div", { ...attributes, className: cxx(styles.stops, className) },
        React.createElement("div", { className: drawConnector ? styles.stops__content : styles.stops__content_no_connector },
            React.createElement("div", { className: drawConnector ? styles.stops__inner : undefined },
                React.createElement(Badge, { text: stops, variant: variant, className: styles.stopsBadge, attributes: { "data-testid": `flight_card_segment_stops_${index}` } }))),
        React.createElement("div", { className: styles.stops__subtext },
            duration ? (React.createElement(Text, { variant: "small_1", attributes: {
                    "aria-hidden": durationAttributes?.ariaHidden,
                    "data-testid": `flight_card_segment_duration_${index}`
                }, align: alignDuration }, duration)) : undefined,
            text ? React.createElement(Text, { variant: "small_2" }, text) : undefined)));
}
